let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7VNs6")).then(() => parcelRequire('g2g56'));